import { AccessModule } from "./access-app/access.module";
import { AppComponent } from "./app.component";
import { AppRoutingModule } from "./app-routing.module";
import { BrowserModule } from "@angular/platform-browser";
import { CallPageModule } from "./caller/caller.module";
import { DriverModule } from "./driver/driver.module";
import { environment } from "../environments/environment";
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
  withJsonpSupport,
} from "@angular/common/http";
import { HttpInterceptorService } from "src/interceptors/http-interceptor.service";
import { IonicModule, IonicRouteStrategy } from "@ionic/angular";
import { IonicStorageModule, Storage } from "@ionic/storage-angular";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { RouteReuseStrategy } from "@angular/router";
import { ServiceWorkerModule } from "@angular/service-worker";
import { ComponentsModule } from "./components/component.module";
import { FormTripPage } from "./caller/form-trip/form-trip.page";
import { ReactiveFormsModule } from "@angular/forms";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { NgxCaptureModule } from "ngx-capture";
import { QRCodeComponent } from "angularx-qrcode";
import { NgxStripeModule } from "ngx-stripe";

@NgModule({
  declarations: [AppComponent, FormTripPage],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    BrowserModule,
    AccessModule,
    CallPageModule,
    ComponentsModule,
    ReactiveFormsModule,
    DriverModule,
    QRCodeComponent,
    IonicModule.forRoot(),
    IonicStorageModule.forRoot(),
    AppRoutingModule,
    ServiceWorkerModule.register("ngsw-worker.js", {
      enabled: environment.production,
    }),
    BrowserAnimationsModule,
    NgxStripeModule.forRoot(environment.stripe.publishKey),
  ],
  providers: [
    Storage,
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpInterceptorService,
      multi: true,
    },
    NgxCaptureModule,
    provideHttpClient(withInterceptorsFromDi(), withJsonpSupport()),
  ],
})
export class AppModule {}
